import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Customer } from '@work4all/models/lib/Classes/Customer.entity';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { CustomerPicker } from '../../../../components/entity-picker/customer-picker/CustomerPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type ICustomerFilterCardProps = {
  title: string;
  value: Customer[] | null;
  onChange: (value: Customer[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
};

export function CustomerFilterCard(props: ICustomerFilterCardProps) {
  const { title, value, onChange, expanded, onExpandedChange, filterConfig } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    return value.length + ' ' + t('COMMON.CHOSEN');
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <CustomerPicker
        layout="advanced"
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        filterConfig={filterConfig}
      />
    </FilterCard>
  );
}
